export default {
  data() {
    return {
      // 是否显示对话框
      dialogFormVisible: false,
      formLabelWidth: '120px',
      // 提问标题
      title: '',
      // 提问内容
      content: '',
      searchUrl: 'answ_question/search',
      createUrl: 'answ_question/create',
      product_id: '',
      user_name: '',
      // 问题列表
      postList: [],
      // 总条数
      total: 1,
      // 当前页
      currentPage: 1,
      // 起始位置
      offset: 0,
      // 返回条数
      length: 10,
    }
  },
  methods: {
    // 前往问题详情
    onToQuestionDetail(post) {
      this.$store.state.isShowQuestionList = true
      this.$router.push({
        path: '/questiondetail',
        query: {
          post: post,
          project_id: this.product_id,
          purchased_id: this.purchased_id
        }
      })
    },

    // 取消提问
    cancelQuestions() {
      this.dialogFormVisible = false
      this.title = ''
      this.content = ''
    },

    // 发起提问
    askingQuestions() {
      this.dialogFormVisible = true
      const {title, content, createUrl} = this
      if (title === '') {
        this.$message({
          message: '请将问题标题填写完整',
          type: 'error'
        });
      } else if(content === '') {
        this.$message({
          message: '请将问题描述填写完整',
          type: 'error'
        });
      } else if (title !== '' && content !== '') {
        const data = {
          token: this.$store.state.id,
          title: title,
          content: content,
          product_id: this.product_id
        }
        this.$post(createUrl, data).then(res => {
          if (res.status === 200) {
            const question = {
              title: title,
              content: content,
              user_name: this.user_name,
              created_at: this.dateFormat(new Date())
            }
            this.postList.unshift(question)
            this.dialogFormVisible = false
            this.title = ''
            this.content = ''
            this.page()
          }
        })
      }
    },
    
    dateFormat (date) {
      const year = date.getFullYear()
      const month = this.addZero(date.getMonth() + 1)
      const day = this.addZero(date.getDate())
      const hour = this.addZero(date.getHours())
      const minute = this.addZero(date.getMinutes())
      const second = this.addZero(date.getSeconds())
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    },

    addZero (number) {
      if (number < 9) {
        return '0' + number
      } else {
        return number
      }
    },

    // pageSize 改变时会触发
    handleSizeChange(val) {
      this.length = val
      this.page()
    },

    // currentPage 改变时会触发
    handleCurrentChange(val) {
      const offset = (val - 1) * this.length
      this.offset = offset
      this.page()
    },

    // 分页
    page() {
      const data = {
        token: this.$store.state.id,
        offset: this.offset,
        length: this.length,
        product_id: this.product_id
      }
      this.$post(this.searchUrl, data).then(res => {
        // console.log(res)
        const data = res.data.result.data
        this.total = res.data.result.total
        this.postList = data
      })
    }
  },
  props: ["purchased_id"],
  mounted() {
    this.page()
  },
  created() {
    this.product_id = this.$route.query.id
    // console.log('purchased_id = ' + this.purchased_id)
    this.user_name = this.$store.state.name
  },
}
